import {
  HEADER_AGENT_APP_NAME,
  HEADER_AGENT_APP_VERSION,
  HEADER_AGENT_CLIENT_ID,
  HEADER_PROVISIONING_ID,
} from "./constants";
import {BaseApp, getProvisioningId} from "./BaseApp";

export abstract class ApiBase {

  private readonly _baseAppPrefs = BaseApp.CONTEXT.getAppPrefs();

  private _sharedHeaders(): any {
    let sharedHeaders: any = {
      [HEADER_AGENT_CLIENT_ID]: this._baseAppPrefs.getClientId(),
      [HEADER_AGENT_APP_NAME]: BaseApp.CONTEXT.getAppConfig()?.name,
      [HEADER_AGENT_APP_VERSION]: "0",
      [HEADER_PROVISIONING_ID]: getProvisioningId(),
    };
    // let hasAuthCredentials = this.appPrefs.hasAuthCredentials();
    // if (requireLogin && !hasAuthCredentials) {
    //   return Promise.reject("User not logged in");
    // }
    // if (hasAuthCredentials) {
    //   let username = this.appPrefs.getUsername();
    //   let password = this.appPrefs.getPassword();
    //   sharedHeaders = {
    //     ...sharedHeaders,
    //     [HEADER_AUTH_USERNAME]: username,
    //     [HEADER_AUTH_PASSWORD]: password,
    //     [HEADER_APP_DOMAIN]: domain,
    //   };
    // }
    return sharedHeaders;
  }

  protected async _asyncGet(url: string, headers: any = {}): Promise<Response> {
    return fetch(url, {
      headers: {
        ...this._sharedHeaders(),
        ...headers,
      },
    });
  }

  protected async _asyncPost(url: string, headers: any = {}, body?: string): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        ...this._sharedHeaders(),
        ...headers,
      },
      body: body,
    });
  }

  protected async _asyncPostJson(url: string, headers: any = {}, bodyJson?: any): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        ...this._sharedHeaders(),
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(bodyJson),
    });
  }
}
